import { useNavigate } from "react-router-dom";

const CTA = ({ children, ...props }) => {
  const navigate = useNavigate();

  // '<svg width="29px" height="20px" viewBox="0 0 29 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="375" transform="translate(-326.000000, -514.000000)" fill="currentColor"> <g id="1-/-header" transform="translate(0.000000, 79.000000)"> <g id="arrows" transform="translate(289.281759, 435.000000)"> <path d="M63.6616915,8.33333333 L43.1568905,8.33333333 L43.1568905,8.33333333 L47.6569723,3.52653415 C48.2764498,2.86483419 48.2757337,1.83583714 47.6553358,1.175 C47.083393,0.565776341 46.1258684,0.53555424 45.5166447,1.10749705 C45.4934393,1.12928242 45.4709272,1.1517946 45.4491418,1.175 L37.1641791,10 L37.1641791,10 L45.4491418,18.825 C46.0210846,19.4342237 46.9786092,19.4644458 47.5878329,18.892503 C47.6110383,18.8707176 47.6335505,18.8482054 47.6553358,18.825 C48.2757337,18.1641629 48.2764498,17.1351658 47.6569723,16.4734658 L43.1568905,11.6666667 L43.1568905,11.6666667 L63.6616915,11.6666667 C64.5821661,11.6666667 65.3283582,10.9204746 65.3283582,10 C65.3283582,9.07952542 64.5821661,8.33333333 63.6616915,8.33333333 Z" id="right" transform="translate(51.246269, 10.000000) scale(-1, 1) translate(-51.246269, -10.000000) "></path> </g> </g> </g> </g> </svg>',
  const icons = {
    "arrow-right":
      '<svg width="32px" height="26px" viewBox="0 0 32 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <polygon id="Path-Copy-3" fill="currentColor" transform="translate(16.377087, 13.000000) rotate(-90.000000) translate(-16.377087, -13.000000) " points="6.89489884 12.5620078 13.8891715 19.5395975 13.8891715 -3 18.8643719 -3 18.8643719 19.3213157 25.8592173 12.3420117 29.3770867 15.8522348 16.3341314 29 3.3770867 16.0728023"></polygon> </g> </svg>',
    download:
      '<svg version="1.1" width="15px" height="17px" viewBox="0 0 15.0 17.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="i0"><path d="M15,0 L15,17 L0,17 L0,0 L15,0 Z"></path></clipPath><clipPath id="i1"><path d="M14.4320684,14.8235294 L14.4320684,16.8 L0,16.8 L0,14.8235294 L14.4320684,14.8235294 Z M10.3086203,0 L10.3086203,5.92941176 L14.4320684,5.92941176 L7.2160342,12.8470588 L0,5.92941176 L4.12344811,5.92941176 L4.12344811,0 L10.3086203,0 Z"></path></clipPath></defs><g clip-path="url(#i0)"><g transform=""><g clip-path="url(#i1)"><polygon points="0,0 14.4320684,0 14.4320684,16.8 0,16.8 0,0" stroke="none" fill="currentColor"></polygon></g></g></g></svg>',
  };

  const isRad = props.href === "#rad-popup";
  const location = `BFCM ${props.segmentLocation ? props.segmentLocation : "general"}`;
  const title = props.isPreFillRad ? "Request a demo" : props.title;

  const handleClick = (e) => {
    // e.preventDefault();

    if (isRad) {
      let formUrl = window.location.origin.includes("localhost")
        ? "http://localhost/yotpo/request-a-demo/"
        : `${window.location.origin}/request-a-demo/`;

      window.location.href = formUrl;
      // const radContent = [
      //   "Want to see what </br>Yotpo can do?",
      //   "Schedule a call with one of our experts before Black Friday to get our BFCM special.",
      // ];
      // document.querySelectorAll(".rad-popup-v3 [data-text]").forEach((el, index) => {
      //   if (radContent[index]) el.innerHTML = radContent[index];
      // });
      // document.querySelector(".rad-popup-v3").dataset.variation = "bfcm";
      // document.querySelector(".rad-popup-v3 [data-formid='1282'] button[type='submit']").innerText = "Request a demo";
    }

    let href = props.href;
    let isUrl = href.startsWith("http");

    const match = props.href.match(/#before|#during|#after/);
    if (match) {
      href = match[0].replace("#", "/") + "#" + href.split("|")[1]; // /before //.slice(1)
      console.log("modified href", href);
    }

    if (!isRad && typeof window.redcross !== "undefined" && !props.isPreFillRad) {
      const obj = {
        btnText: title,
        btnContext: href,
        btnName: props.segmentBtnName ? props.segmentBtnName : title,
        btnLocation: location,
      };

      window.redcross.track("Button Clicked", obj, {}, function () {
        isUrl ? window.open(href, "_self") : navigate(href);
      });
    } else {
      if (!isRad) isUrl ? window.open(href, "_self") : navigate(href);
    }
  };

  return (
    <>
      {isRad ? (
        <button
          type="submit"
          className={"pre_fill_rad_v3_btn" + " " + props.className}
          // onClick={(e) => handleClick(e)}
          data-aos={props.aos}
          data-location={location}
        >
          {props.withChildren ? (
            children
          ) : (
            <>
              <span className="cta-text">{title}</span>
              {props.icon ? (
                <span className="cta-icon" dangerouslySetInnerHTML={{ __html: icons[props.icon] }}></span>
              ) : null}
            </>
          )}
        </button>
      ) : (
        <a
          href={props.href}
          className={props.className}
          download={props.download}
          // target="_blank"
          rel="noreferrer"
          onClick={(e) => handleClick(e)}
          data-aos={props.aos}
          data-location={location}
        >
          {props.withChildren ? (
            children
          ) : (
            <>
              <span className="cta-text">{title}</span>
              {props.icon ? (
                <span className="cta-icon" dangerouslySetInnerHTML={{ __html: icons[props.icon] }}></span>
              ) : null}
            </>
          )}
        </a>
      )}
    </>
  );
};

export default CTA;
